export function getAiPrompts() {
  const promptsList = [
    {
      id: 1,
      prompt: 'I would like to schedule an oil change on Monday at 10am.',
    },
    {
      id: 2,
      prompt: 'Do you have any active service coupons?',
    },
    {
      id: 3,
      prompt: 'Can I find the trade in value for my current vehicle?',
    },
    {
      id: 4,
      prompt: 'Do you have any bonus offers?',
    },
    {
      id: 5,
      prompt: 'What are the lease payment options of a new vehicle?',
    },
  ];
  return promptsList;
}
